import { SETTING_CONST } from '../action/setting.action'

const initialState = {
    current_tab: 0,
    notification_text: "Уведомления",
    no_component_text: "не подключено",
    ready_component_text: "подключено",
    container_component_text: "Необходимые компоненты",
    token: "",
    token_saved: "",
    is_token_saved: true,
    token_save_btn_text: "Сохранить",
    token_wait_normal_btn_text: "Сохранить",
    token_wait_save_btn_text: "Сохранение",
    token_err_save_btn_text: "Не сохранено",
    token_cancel_btn_text: "Отменить",
    token_field_descr_text: "Ключ API - ",
    toggle_integration_text: "Интеграция",
    is_toggle_integration_enable: false,
    is_integration: false,
    error_text_component:"Для подключения необходимых компонентов, обратитесь к Вашему персональному менеджеру",
    tab_settings_text: "Настройки интеграции",
    expansionPanel_expanded: false,
    app_id: "",
    customer_id: "",
    login: "",
    password: "",
    copy_clipboard_btn_text: "КОПИРОВАТЬ",
    is_show_popup_copy: false,
    anchor_popup: null,
    copy_ready_text: "cкопированно",

    login_field: "",
    login_field_saved: "",
    login_field_descr_text: "Логин салона (например: msc_romashka)",
    is_login_saved: true,

    id_salon: "",
    id_salon_saved: "",
    id_salon_descr_text: "ID салона (например: 123456)",
    is_id_salon_saved: true
}

export default function reducer(state = initialState, action){
    switch (action.type){
        case SETTING_CONST.UPDATE_TAB_SELECT:
            return { ...state, current_tab: action.payload }
        // поле токена
        case SETTING_CONST.CHANGE_TOKEN:
            return { ...state, token: action.payload, is_token_saved: action.payload !== state.token_saved? false: true }
        case SETTING_CONST.SET_TOKEN:
            return {...state, token: action.payload, token_saved: action.payload }
        case SETTING_CONST.SAVE_TOKEN:
            return { ...state, token_saved: state.token, is_token_saved: true, token_save_btn_text: state.token_wait_normal_btn_text  }
        case SETTING_CONST.WAIT_SAVE_TOKEN:
            return { ...state, token_save_btn_text: state.token_wait_save_btn_text }
        case SETTING_CONST.CANCEL_TOKEN:
            return { ...state, token: state.token_saved, is_token_saved: true }
        case SETTING_CONST.DEFAULT_SAVE_TOKEN:
            return { ...state, token_save_btn_text: state.token_wait_normal_btn_text }
        case SETTING_CONST.ERR_SAVE_TOKEN:
            return { ...state, token_save_btn_text: state.token_err_save_btn_text }

        // поле login
        case SETTING_CONST.SET_LOGIN:
            return {...state, login_field: action.payload, login_field_saved: action.payload}
        case SETTING_CONST.CHANGE_LOGIN:
            return { ...state, login_field: action.payload, is_login_saved: action.payload != state.login_field_saved? false: true }
        case SETTING_CONST.SAVE_LOGIN:
            return { ...state, login_field_saved: state.login_field, is_login_saved: true, token_save_btn_text: state.token_wait_normal_btn_text  }
        case SETTING_CONST.CANCEL_LOGIN:
            return { ...state, login_field: state.login_field_saved, is_login_saved: true }
       
        // переключатель интеграции
        case SETTING_CONST.SET_INTEGRATION_ENABLE:
            return { ...state, is_toggle_integration_enable: action.payload }

        case SETTING_CONST.SET_UIS_ID:
            return { ...state, app_id: action.payload.appId, customer_id: action.payload.customerId }
        case SETTING_CONST.SET_INTEGRATION:
            return {...state, is_integration: action.payload, is_toggle_integration_enable: true }
        case SETTING_CONST.SET_ID_SALON:
            return {...state, id_salon: action.payload, id_salon_saved: action.payload}
        case SETTING_CONST.SAVE_ID:
            return {...state, is_id_salon_saved: true, id_salon_saved: state.id_salon}
        case SETTING_CONST.SET_AUTH:
            return { ...state, login: action.payload.login, password: action.payload.pass}
        case SETTING_CONST.EXPANSION_PANEL_EXPANDED:
            return {...state, expansionPanel_expanded: action.payload==null? !state.expansionPanel_expanded: action.payload}
        case SETTING_CONST.STATE_POPUP:
            return {...state, anchor_popup: action.payload, is_show_popup_copy:  action.payload==null? false: true}
        case SETTING_CONST.CHANGE_ID_SALON:
            return {...state, id_salon: action.payload, is_id_salon_saved: false}
        case SETTING_CONST.CANCEL_ID:
            return {...state, id_salon: state.id_salon_saved, is_id_salon_saved: true}
        default:
            return state
    }
}